import React from 'react'


import corporate from "../Image/images (8).jpg"
import bannerpost from "../Image/career.png"

function Careerpage() {
  return (
    <>
      <section className=''>
        <div style={{ backgroundImage: `url(${bannerpost})`, height: "70vh", backgroundRepeat: "no-repeat", backgroundSize: "cover" }}>
        </div>
      </section>
      <section className="about-agencys pad-tb block-1 dark-bg3">
        <div className="container">
          <div className="row justify-content-between">
            <div className="col-lg-6">
              <div className="common-heading text-l">
                <h2 className="mb20">Career and Culture at N D Techland</h2>
                <p>IT Sector is an exceptionally extending and cutthroat industry. Also, an all around the world regarded position is acquired exclusively by a mix of skilled people, effective techniques and steady outcomes. That is the mystery behind the great development paces of N D Techland and it's customers.</p>
                <p>We're generally quick to meet gifted, amicable individuals. In the event that that seems like you, and you like the appearance of us as well, connect to us.</p>
                <a href="#jobs" className="btn-main bg-btn2 lnk mt30"> View Opening <i className="fas fa-chevron-right fa-icon"></i><span className="circle"></span></a>
              </div>
            </div>
            <div className="col-lg-5">
              <div className="image-block mb0 m-mt30">
                <img
                  src="https://www.lcs.com/wp-content/uploads/2024/04/User-Interface-Development-Team.jpg"
                  alt="about"
                  className="img-fluid"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="service-block pad-tb bg-gradient7">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <div className="common-heading ptag">
                <h2>Perks To Work With N D Techland</h2>
                <p className="mb30">
                  One thing about benefits: everyone loves them. Casual leaves, paid
                  leaves, incentives and outings are some of the standard advantages
                  for employees.
                </p>
              </div>
            </div>
          </div>

          <div className="row justify-content-center">
            {/* Card 1 */}
            <div className="col-lg-4 col-sm-6 mt30 wow fadeIn" data-wow-delay=".2s" style={{ display: "flex" }}>
              <div
                className="s-block wide-sblock"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  height: "100%",
                  minHeight: "250px", // ✅ same size
                  padding: "20px",
                  borderRadius: "10px",
                  background: "#fff",
                  boxShadow: "0 2px 10px rgba(0,0,0,0.1)"
                }}
              >
                <div className="s-card-icon">
                  <img src="images/icons/teama.svg" alt="service" className="img-fluid" />
                </div>
                <div className="s-block-content" style={{ flexGrow: 1 }}>
                  <h4>Casual & Paid Leaves</h4>
                  <p>Because we know the importance of work-life balance.</p>
                </div>
              </div>
            </div>

            {/* Card 2 */}
            <div className="col-lg-4 col-sm-6 mt30 wow fadeIn" data-wow-delay=".5s" style={{ display: "flex" }}>
              <div
                className="s-block wide-sblock"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  height: "100%",
                  minHeight: "250px", // ✅ same size
                  padding: "20px",
                  borderRadius: "10px",
                  background: "#fff",
                  boxShadow: "0 2px 10px rgba(0,0,0,0.1)"
                }}
              >
                <div className="s-card-icon">
                  <img src="images/icons/link.svg" alt="service" className="img-fluid" />
                </div>
                <div className="s-block-content" style={{ flexGrow: 1 }}>
                  <h4>Performance Incentives</h4>
                  <p>Your hard work never goes unnoticed; we reward excellence.</p>
                </div>
              </div>
            </div>

            {/* Card 3 */}
            <div className="col-lg-4 col-sm-6 mt30 wow fadeIn" data-wow-delay=".8s" style={{ display: "flex" }}>
              <div
                className="s-block wide-sblock"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  height: "100%",
                  minHeight: "250px", // ✅ same size
                  padding: "20px",
                  borderRadius: "10px",
                  background: "#fff",
                  boxShadow: "0 2px 10px rgba(0,0,0,0.1)"
                }}
              >
                <div className="s-card-icon">
                  <img src="images/icons/tech.svg" alt="service" className="img-fluid" />
                </div>
                <div className="s-block-content" style={{ flexGrow: 1 }}>
                  <h4>Team Outings & Celebrations</h4>
                  <p>Building stronger bonds beyond work.</p>
                </div>
              </div>
            </div>

            {/* Card 4 */}
            <div className="col-lg-4 col-sm-6 mt30 wow fadeIn" data-wow-delay="1.1s" style={{ display: "flex" }}>
              <div
                className="s-block wide-sblock"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  height: "100%",
                  minHeight: "250px", // ✅ same size
                  padding: "20px",
                  borderRadius: "10px",
                  background: "#fff",
                  boxShadow: "0 2px 10px rgba(0,0,0,0.1)"
                }}
              >
                <div className="s-card-icon">
                  <img src="images/icons/hi.svg" alt="service" className="img-fluid" />
                </div>
                <div className="s-block-content" style={{ flexGrow: 1 }}>
                  <h4>Skill Development Opportunities</h4>
                  <p>Regular training sessions and learning programs to help you grow.</p>
                </div>
              </div>
            </div>

            {/* Card 5 */}
            <div className="col-lg-4 col-sm-6 mt30 wow fadeIn" data-wow-delay="1.4s" style={{ display: "flex" }}>
              <div
                className="s-block wide-sblock"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  height: "100%",
                  minHeight: "250px", // ✅ same size
                  padding: "20px",
                  borderRadius: "10px",
                  background: "#fff",
                  boxShadow: "0 2px 10px rgba(0,0,0,0.1)"
                }}
              >
                <div className="s-card-icon">
                  <img src="images/icons/badge.svg" alt="service" className="img-fluid" />
                </div>
                <div className="s-block-content" style={{ flexGrow: 1 }}>
                  <h4>Flexible Work Culture</h4>
                  <p>A supportive environment that values productivity over strict schedules.</p>
                </div>
              </div>
            </div>

            {/* Card 6 */}
            <div className="col-lg-4 col-sm-6 mt30 wow fadeIn" data-wow-delay="1.7s" style={{ display: "flex" }}>
              <div
                className="s-block wide-sblock"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  height: "100%",
                  minHeight: "250px", // ✅ same size
                  padding: "20px",
                  borderRadius: "10px",
                  background: "#fff",
                  boxShadow: "0 2px 10px rgba(0,0,0,0.1)"
                }}
              >
                <div className="s-card-icon">
                  <img src="images/icons/tin.svg" alt="service" className="img-fluid" />
                </div>
                <div className="s-block-content" style={{ flexGrow: 1 }}>
                  <h4>Recognition & Rewards</h4>
                  <p>Appreciating contributions that make a difference.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="contact-page pad-tb" id="jobs">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <div className="common-heading ptag">

                <h2>Current Openings</h2>
                <p className="mb60"> Latest Jobs</p>
              </div>
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <div className="career-card-div">
                <div className="accordion" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="headingOne">
                      <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapse-1" aria-expanded="true" aria-controls="collapseOne">
                        .NET - 1 Post
                      </button>
                    </h2>
                    <div id="collapse-1" className="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                      <div className="accordion-body">
                        <div className="data-reqs">
                          <h5 className="pt20 pb20">Overview</h5>
                          <p>.NET is a versatile, powerful platform for building modern applications efficiently, across devices and operating systems, using multiple programming languages. </p>
                          <h5 className="pt20 pb20">Required experience</h5>
                          <p>A 2–3 year .NET developer is expected to write efficient code, work on web/desktop apps, integrate databases and APIs, and start contributing to architecture discussions under the guidance of senior developers. </p>
                          <h4 className="pb20 pt20">Skills Required:</h4>
                          <ul className="list-ul ul-check">
                            <li>Good problem-solving ability</li>
                            <li>Team collaboration and communication</li>
                            <li>Time management and ability to meet deadlines</li>
                            <li>Willingness to learn and adapt to new technologies</li>
                            <li>Database Management: SQL Server, MySQL, PostgreSQL</li>
                            <li>Strong knowledge in database (Mysql)</li>
                            <li>Good Knowledge in Google APIs</li>
                            <li>Cloud & DevOps: Azure, AWS, CI/CD pipelines, Docker, Kubernetes</li>
                            <li>Strong object oriented programming and design skills</li>
                            <li>API Integration: RESTful & SOAP Web Services</li>
                          </ul>
                          <a href="#" className="btn-main bg-btn3 lnk mt20" data-bs-toggle="modal" data-bs-target="#modalform">Apply Now<i className="fas fa-chevron-right fa-icon"></i><span className="circle"></span></a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="headingOne">
                      <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapse-2" aria-expanded="true" aria-controls="collapseOne">
                        flutter - 2 Post
                      </button>
                    </h2>
                    <div id="collapse-2" className="accordion-collapse collapse" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                      <div className="accordion-body">
                        <div className="data-reqs">
                          <h5 className="pt20 pb20">Overview</h5>
                          <p>Flutter is a modern, efficient, and flexible framework for building cross-platform applications with beautiful UIs and high performance, all using one codebase written in Dart. </p>
                          <h5 className="pt20 pb20">Required experience</h5>
                          <p>Would you like me to also create a resume-ready “Required Experience” content snippet for a 2–3 year Flutter developer, like I did earlier for .NET?</p>
                          <h4 className="pb20 pt20">Skills Required:</h4>
                          <ul className="list-ul ul-check">
                            <li>Deep expertise in Flutter & Dart</li>
                            <li>Advanced state management & architecture patterns (MVVM, Clean Architecture)</li>
                            <li>Strong knowledge of native Android (Java/Kotlin) & iOS (Swift/Objective-C) interop</li>
                            <li>Experience with microservices, GraphQL, and advanced APIs</li>
                            <li>Strong skills in DevOps, CI/CD, Docker, cloud deployment (Firebase/AWS/Azure).</li>
                            <li>Leadership & mentoring experience</li>
                            <li>Good Knowledge in  APIs</li>
                            <li>Integration with APIs, Firebase, SQLite/local storage</li>
                            <li>Understanding of app lifecycle, performance optimization</li>
                            <li>Handle API integrations, push notifications, authentication</li>
                          </ul>
                          <a href="#" className="btn-main bg-btn3 lnk mt20" data-bs-toggle="modal" data-bs-target="#modalform">Apply Now<i className="fas fa-chevron-right fa-icon"></i><span className="circle"></span></a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="popup-modals">
        <div className="modal" id="modalform">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header bg-danger">
                <div className="common-heading">
                  <h4 className="mt0 mb0 ">Post Your Resume</h4>
                </div>
                <button type="button" className="closes" data-bs-dismiss="modal">&times;</button>
              </div>
              <div className="modal-body pt40 pb60">
                <div className="form-block fdgn2">
                  <h4>Personal Details</h4>
                  <form id="contact-form" method="post" action="#">
                    <div className="fieldsets row">
                      <div className="col-md-6 form-group"><input id="form_name" type="text" name="name" placeholder="Enter your name *" required="required" /> </div>
                      <div className="col-md-6 form-group"><input id="form_email" type="email" name="email" placeholder="Enter your email *" required="required" /> </div>
                    </div>
                    <div className="fieldsets row">
                      <div className="col-md-6 form-group"><input id="form_phone" type="text" name="phone" placeholder="Enter your Phone No *" required="required" />	</div>
                      <div className="col-md-6 form-group"><input id="form_phone" type="text" name="phone" placeholder="City *" required="required" />	</div>
                    </div>
                    <div className="fieldsets form-group"> <textarea id="form_message" name="message" placeholder="Address *" rows="4" required="required"></textarea> </div>
                    <h4>Qualification</h4>
                    <div className="fieldsets row">
                      <div className="col-md-6 form-group"><input id="form_phone" type="text" name="phone" placeholder="Degree *" required="required" />	</div>
                      <div className="col-md-6 form-group">
                        <select id="form_need" name="need" required="required">
                          <option value="">Select Post</option>
                          <option value="Graphic Design">Graphic Design</option>
                          <option value="Web Design">Web Design</option>
                          <option value="App Design">App Design</option>
                          <option value="Other">Other</option>
                        </select>
                      </div>
                    </div>
                    <div className="fieldsets- row">
                      <div className="col-md-12 form-group">
                        <div className="custom-file">
                          <input type="file" className="custom-file-input mb0" id="customFile" />
                          <label className="custom-file-label" for="customFile">Choose file</label>
                        </div>
                        <p><small>Please upload maximum 5 files Only pdf, docx and doc files.</small></p>
                      </div>
                    </div>
                    <div className="fieldsets mt20">
                      <button type="button" className="lnk btn-main bg-btn">Post Here<span className="circle"></span></button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Careerpage